<template>
  <div :class="loginPageBase">
    <div class="login-page-content">
      <div :class="loginPageImg"></div>
      <div :class="loginPageLight">
        <div class="login-form-content">
          <div :class="['login-title', loginPageFontColor]">
            {{ $t('JHLoginTips1') }}
          </div>
          <div v-if="loginType == 'account'">
            <div class="login-tip">{{ $t('JHLoginTips2') }}</div>
            <!-- 账号 -->
            <el-input :placeholder="$t('JHPleaseEnter',{0:$t('JHAccount')})" suffix-icon="el-icon-user" v-model="userAccount" class="custom-input-size" />

            <!--    <div
              class="get-phone-code-btn phone-code-btn-active"
              @click="createRandomCode()"
            >{{randomStr}}</div>
            <el-input class="custom-input-size-small" placeholder="请输入算式结果" v-model="phoneCode"></el-input>
            -->
            <!--          <div-->
            <!--            :class="phoneCodeBtnText==='获取验证码'?'get-phone-code-btn phone-code-btn-active':'get-phone-code-btn phone-code-btn-disable'"-->
            <!--            @click="getPhoneCode()"-->
            <!--          >{{phoneCodeBtnText}}</div>-->
            <!--          <el-input class="custom-input-size-small" placeholder="请输入验证码" v-model="phoneCode"></el-input>-->
            <el-input :placeholder="$t('JHPleaseEnter',{0:$t('JHPassword')})" type="password" show-password v-model="userPwd" class="custom-input-size" />
            <div :class="['password-tips', loginPageFontColor]">
              <div class="forget-pwd" @click="goForgetPwd">{{ $t('JHForgetPWD') }}</div>
              <div class="remember-pwd">
                <el-checkbox :class="loginPageFontColor" v-model="checked">{{ $t('JHRememberPWD') }}</el-checkbox>
              </div>
            </div>
            <div :class="['login-btn', loginPageBtnBg]" @click="login">{{ $t('JHLogin') }}</div>
            <div style="display: flex;align-items: center">
              <div :class="['regeister-btn', loginPageFontColor]" @click="goRegister" style="flex:1;text-align: left">
                {{ $t('JHLoginTips3') }}
              </div>
              <div  :class="['regeister-btn', loginPageFontColor]" @click="changeLoginType('phone')" style="flex:1;text-align: right">手机号登录</div>
            </div>
          </div>
          <div v-if="loginType == 'phone'">
            <!-- 账号 -->
            <div style="padding: 20px 0;" @click="changeLoginType('account')">
              <i style="color: #3894ff" class="el-icon-back"></i><span class="primary-color">账号密码登录</span>
            </div>
            <el-input class="custom-input-size" placeholder="请输入手机号" suffix-icon="el-icon-user" v-model="userPhone"></el-input>

            <div class="phone-code">
              <el-input v-model="phoneCode" placeholder="获取验证码"></el-input>
              <div :class="phoneActive ? 'btn btn-active' : 'btn btn-default'" @click="getPhoneLoginCode()">
                {{ pwdText }}
              </div>
            </div>
            <div :class="['login-btn', loginPageBtnBg]" @click="loginByPhone">{{ $t('JHLogin') }}</div>
          </div>

        </div>
      </div>
    </div>
    <div class="login-fot">
      <a href="https://beian.miit.gov.cn">
        备案号：沪ICP备12013583号-1
      </a> <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011202008339">
        沪公安网备31011202001146
      </a> ©Copyright 2019 上海精函信息科技有限公司版权所有
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Input, Checkbox } from "element-ui";
import {
  USER_NAME,
  USER_PWD,
  TIMESTAMP,
  UPDATE_PWD_TIME,
  UPDATE_PWD_TIME_CANCEL,
  TOKEN, LOGIN_TYPE
} from "../../../api/localStorageName";
import md5 from "md5";
Vue.use(Input).use(Checkbox);
var timeInterval;
export default {
  name: "login",
  data() {
    return {
      randomRes: null, //随机生成算式的结果
      randomStr: "", //随机生成的算式
      userAccount:'', //账号
      userPwd: '', //密码
      phoneCode: "",
      type: "distributor",
      loginPageBase: "", //页面的主题颜色
      loginPageImg: "", //页面左侧的背景图片
      loginPageLight: "", //页面右侧的背景图片
      loginPageBtnBg: "", //页面按钮背景颜色
      loginPageFontColor: "", //页面文字颜色\
      phoneCodeBtnText: this.$t("JHObtain") + this.$t("JHVerificationCode"),
      checked: true, //记住密码

      loginType:'account',//account-账号密码/phone-手机号/scan-扫码登录
      pwdText: '获取验证码',
      phoneActive:true,
      userPhone:'',
      phoneMsgId: "", // 验证码id
      phoneTimer:null,

    };
  },
  watch: {},
  created() {
    this.initPageStyle();
    this.createRandomCode();
    // this.checkLongin();

    this.userAccount = localStorage.getItem(USER_NAME) ? localStorage.getItem(USER_NAME) : '';
    this.userPwd = localStorage.getItem(USER_PWD) ? localStorage.getItem(USER_PWD) : '';


    let updatePwdTime = localStorage.getItem(UPDATE_PWD_TIME);
    let updatePwdTimeCancel = localStorage.getItem(UPDATE_PWD_TIME_CANCEL);
    console.log('formatDate==',this.$utils.formatDate('YYYY-mm-dd HH:MM:SS'),new Date())
    if(updatePwdTime){
      let updateTime = new Date(updatePwdTime);
      let currentTime = new Date();
      let daysDiff = (currentTime.getTime() - updateTime.getTime()) / (1000 * 3600 * 24);
      console.log('daysDiff',daysDiff)
      if(daysDiff > 90){
        if(updatePwdTimeCancel){
          // 手动拒绝修改密码时间
          let  daysDiff2 = (currentTime.getTime() - new Date(updatePwdTimeCancel).getTime()) / (1000 * 3600 * 24);
          console.log('daysDiff2',daysDiff2)
          if(daysDiff2 > 30){
            this.showEditPwdTips();
          }
        }else{
          this.showEditPwdTips();
        }
      }
    }

    let token = localStorage.getItem(TOKEN);
    if(token && localStorage.getItem(LOGIN_TYPE) == 'phone'){
      this.$router.push({ path: "/agent/info" });
      this.judgePublic();
    }
  },
  destroyed() {
    clearInterval(timeInterval);
  },
  methods: {
    // 提示修改密码
    showEditPwdTips(){
      let _this = this;
      this.$confirm(this.$t('remindEditPwdTips'), this.$t('JHTips'), {
        confirmButtonText: this.$t('toEditPwd'),
        cancelButtonText: this.$t('noReminder30'),
        type: 'warning'
      }).then(() => {
        _this.goForgetPwd();
      }).catch(() => {
        let time = _this.$utils.formatDate(('YYYY-mm-dd HH:MM:SS'),new Date())
        localStorage.setItem(UPDATE_PWD_TIME_CANCEL,time)
      });
    },
    changeLoginType(type){
      this.loginType = type
    },
    getPhoneLoginCode() {
      // 修改密码获取验证码
      if (!this.userPhone) {
        this.$message.warning("请输入手机号");
        return;
      }
      if (!this.phoneActive) return;
      this.phoneActive = false;
      this.$http
        .post(
          this.$path.getMsgLoginCode,
          {
            account: this.userPhone,
          },
          { headers: { temporary: 1 } }
        )
        .then((res) => {
          console.log(res)
          if (res && res.msgId) {
            this.$message.success('验证码发送成功');
            this.phoneActive = false;
            this.phoneMsgId = res.msgId;
            let time = 60;
            this.phoneTimer = setInterval(() => {
              this.pwdText = `${time}s后重新获取`;
              time = time - 1;
              if (time == 0) {
                clearInterval(this.phoneTimer);
                this.pwdText = '获取验证码';
                this.phoneActive = true;
              }
            }, 1000);
          } else {
            this.$message.error('验证码发送失败');
          }
        })
        .catch((err) => {
          this.phoneActive = true;
          console.error(err);
        });
    },
    // 验证码登录
    async loginByPhone(){
      //登录
      const userAccount = this.userPhone;
      const msgCode = this.phoneCode;
      const msgId = this.phoneMsgId;

      if (!userAccount) {
        this.$message.error(
          this.$t("JHPleaseEnter", { 0: this.$t("JHAccount") })
        );
        return;
      }
      if (!msgCode) {
        this.$message.error(
          this.$t("JHPleaseEnter", { 0: this.$t("JHVerificationCode") })
        );
        return;
      }
      const loginData = {
        account: userAccount,
        loginCode:msgCode,
        loginId:msgId,
        authType:'6'
      };
      const loginRes = await this.$store.dispatch("login", loginData);
      console.log(loginRes);
      if (loginRes && loginRes.status) {
        localStorage.setItem(LOGIN_TYPE, 'phone');
        this.$router.push({ path: "/agent/info" });
        this.judgePublic();
      } else {
        this.$message.error(this.$t("JHFail", { 0: this.$t("JHLogin") }));
      }
    },
    // 账号密码登录
    async login() {
      //登录
      const userAccount = this.userAccount;
      const userPwd = this.userPwd;
      const phoneCode = this.phoneCode;
      if (!userAccount) {
        this.$message.error(
          this.$t("JHPleaseEnter", { 0: this.$t("JHAccount") })
        );
        return;
      }
      if (!userPwd) {
        this.$message.error(
          this.$t("JHPleaseEnter", { 0: this.$t("JHPassword") })
        );
        return;
      }
      if(!this.$utils.passwordRegex.test(userPwd)){
        this.$message.error('您的密码不符合公安部要求，请点击【忘记密码】，按要求修改密码后重新登录')
        return
      }
      const loginData = {
        account: userAccount,
        pwd: md5("agent" + userPwd),
      };
      const loginRes = await this.$store.dispatch("login", loginData);
      console.log('loginRes====',loginRes);
      if (loginRes && loginRes.status) {
        if (this.checked) {
          //记住密码
          localStorage.setItem(USER_NAME, this.userAccount);
          localStorage.setItem(USER_PWD, this.userPwd);
          localStorage.setItem("ossFolder", "distributor");
        }
        localStorage.setItem(UPDATE_PWD_TIME, loginRes.res.updatePwdTime);
        this.$router.push({ path: "/agent/info" });
        this.judgePublic();
      } else {
        this.$message.error(this.$t("JHFail", { 0: this.$t("JHLogin") }));
      }
    },
    judgePublic() {
      var change = localStorage.getItem("change");
      change = JSON.parse(change);
      var sign = change.userSign;
      var userId = localStorage.getItem("userId");
      this.$http
        .post(this.$path.bindMultipleAccount, {
          bindSign: sign,
          bindId: userId,
          type: "ES",
        })
        .then((res) => {
          console.log(res);
          // localStorage.getItem("openId",JSON)
          if (res) {
            localStorage.setItem("openId", JSON.stringify(res[0].openId));
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goRegister() {
      this.$router.push({ path: "/register" });
    },
    goForgetPwd() {
      this.$router.push({ path: "/forgetPwd" });
    },
    createRandomCode() {
      const num1 = Math.floor(Math.random() * (100 - 10 + 1) + 10);
      const num2 = Math.floor(Math.random() * (100 - 10 + 1) + 10);
      this.randomRes = num1 + num2;
      this.randomStr = `${num1}  +  ${num2}  =  ?`;
    },
    async getPhoneCode() {
      let phoneCodeBtnText =
        this.$t("JHObtain") + this.$t("JHVerificationCode");
      if (this.phoneCodeBtnText !== phoneCodeBtnText) return;
      const userAccount = this.userAccount;
      if (
        !userAccount
        // userAccount.length !== 11 ||
        // !userAccount.startsWith("1")
      ) {
        this.$message.error(
          this.$t("JHPleaseEnter", { 0: this.$t("JHAccount") })
        );
        return;
      }
      const loginRes = await this.$store.dispatch("getPhoneCode", userAccount);
      if (loginRes && loginRes.status) {
        this.startInterval();
      } else {
        this.$message.error(this.$t("JHFail", { 0: phoneCodeBtnText }));
        // this.$message.error(`获取验证码失败`);
      }
    },
    startInterval() {
      const _this = this;
      let time = 60;
      timeInterval = setInterval(() => {
        --time;
        if (time < 0) {
          clearInterval(timeInterval);
          _this.phoneCodeBtnText =
            this.$t("JHObtain") + this.$t("JHVerificationCode");
          return;
        }
        _this.phoneCodeBtnText = `${time}S` + this.$t("JHObtain");
      }, 1000);
    },
    checkLongin() {
      return;
      /*  const userId = this.$store.state.userId;
        const token = this.$store.state.token;
        const userInfo = this.$store.state.userInfo;
        const timestamp = localStorage.getItem(TIMESTAMP);
        const timestampDate = timestamp ? new Date(timestamp) : new Date();
        const nowDateTime = new Date().getTime();
        if (
          userId &&
          token &&
          userInfo &&
          timestamp &&
          nowDateTime - timestampDate < 2 * 60 * 60 * 1000
        ) {
          //有缓存的登录信息，且信息有效
          this.$router.push({ path: "/systemParams/language" });
        } */
    },
    initPageStyle() {
      const type = this.type;
      if (type === "admin") {
        this.loginPageBase = "login-page-base-admin login-page-base";
        this.loginPageImg = "content-left-admin content-left";
        this.loginPageLight = "content-right-admin content-right";
        this.loginPageBtnBg = "admin-background-color";
        this.loginPageFontColor = "admin-font-color";
      }
      if (type === "merchant") {
        this.loginPageBase = "login-page-base-merchant login-page-base";
        this.loginPageImg = "content-left-merchant content-left";
        this.loginPageLight = "content-right-merchant content-right";
        this.loginPageBtnBg = "merchant-background-color";
        this.loginPageFontColor = "merchant-font-color";
      }
      if (type === "distributor") {
        this.loginPageBase = "login-page-base-distributor login-page-base";
        this.loginPageImg = "content-left-distributor content-left";
        this.loginPageLight = "content-right-distributor content-right";
        this.loginPageBtnBg = "distributor-background-color";
        this.loginPageFontColor = "distributor-font-color";
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../../theme/index.scss";
.login-fot {
  font-size: 12px;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  text-align: center;
  padding: 10px 0;
  a {
    padding: 0 10px;
    text-decoration: none;
    color: #333;
  }
  a:hover {
    color: #3b78f1;
  }
}
.login-page-base-admin {
  background: linear-gradient(#5689fe, #7bb3fe);
}
.login-page-base-merchant {
  background: linear-gradient(#5689fe, #7bb3fe);
}
.login-page-base-distributor {
  background: linear-gradient($primary-color, #7bb3fe);
}
.login-page-base {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 600;
  .admin-background-color {
    background-color: #f6a44c;
  }
  .merchant-background-color {
    background-color: #5689fe;
  }
  .distributor-background-color {
    background-color: $primary-color;
  }
  .admin-font-color {
    color: #f6a44c;
  }
  .merchant-font-color {
    color: #5689fe;
  }
  .distributor-font-color {
    color: $primary-color;
  }
  .login-page-content {
    width: 92vw;
    height: 86vh;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    .content-left,
    .content-right {
      flex: 1;
      height: 86vh;
      background-color: #fff;
      background-repeat: no-repeat;
    }
    .content-left {
      background-position: center;
      background-size: 46vw 86vh;
    }
    .content-left-admin {
      background-image: url("../../assets/login/admin-login.png");
    }
    .content-left-merchant {
      background-image: url("../../assets/login/merchant-login.png");
    }
    .content-left-distributor {
      background-image: url("../../assets/login/distributor-login.png");
    }
    .content-right-admin {
      background-image: url("../../assets/login/admin-light.png");
    }
    .content-right-merchant {
      background-image: url("../../assets/login/merchant-light.png");
    }
    .content-right-distributor {
      background-image: url("../../assets/login/distributor-light.png");
    }
    .content-right {
      background-position: 38vw 0;
      background-size: 60px 190px;
      .login-form-content {
        padding-top: 160px;
        width: 30vw;
        margin: 0 auto;
        .login-title {
          font-size: 36px;
        }
        .login-tip {
          color: #666;
          font-size: 14px;
          margin-top: 2vh;
          margin-bottom: 4vh;
        }
        .custom-input-size {
          display: block;
          margin-bottom: 2vh;
        }
        .custom-input-size-small {
          width: 50%;
          display: block;
          margin-bottom: 2vh;
        }
        .get-phone-code-btn {
          height: 40px;
          line-height: 40px;
          vertical-align: middle;
          width: 30%;
          float: right;
          font-size: 14px;
          text-align: center;
          border-radius: 5px;
        }
        .phone-code-btn-active {
          background: $primary-color;
          color: #fff;
          cursor: pointer;
        }
        .phone-code-btn-disable {
          background: #f5f7fa;
          color: #909399;
          cursor: not-allowed;
        }
        .password-tips {
          font-size: 14px;
          height: auto;
          overflow: hidden;
          .forget-pwd {
            float: left;
            cursor: pointer;
          }
          .remember-pwd {
            float: right;
            cursor: pointer;
          }
        }
        .login-btn {
          width: 30vw;
          height: 6vh;
          text-align: center;
          line-height: 6vh;
          vertical-align: middle;
          color: #fff;
          border-radius: 999px;
          font-size: 26px;
          margin-top: 3vh;
          cursor: pointer;
        }
        .regeister-btn {
          font-size: 14px;
          text-align: center;
          cursor: pointer;
          margin-top: 2vh;
        }
      }
    }
  }
}
.phone-code {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .input {
    flex: 1;
  }

  .btn {
    padding: 0 10px;
    margin: 0 10px;
    border-radius: 5px;
  }

  .btn-active {
    background: #2971f6;
    color: #fff;
    cursor: pointer;
  }

  .btn-default {
    background: #ededee;
    color: #666;
    cursor: not-allowed;
  }
}
.phone-code{
  align-items: center;
  height: 40px;
  line-height: 40px;
  padding-bottom: 20px;
}
.phone-code .btn{
  height: 100%!important;
  text-align: center;
  width: 160px;
}
</style>



// WEBPACK FOOTER //
// src/components/login/index.vue